export default function ChevronFilled({ fill = "#fff", className = "", width = 15, height = 10 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 15 10"
      className={className}
    >
      <path
        id="Polygon_7"
        data-name="Polygon 7"
        d="M7.5,0,15,10H0Z"
        transform="translate(15 10) rotate(180)"
        fill={fill}
      />
    </svg>
  );
}
